import { CookieService } from './Services/CookieService';
import constants from './constants';

export class TagManagerModule {

    constructor() {
        this.settingsCookie = new CookieService(constants.COOKIES.SETTINGS_COOKIE);
        this.hasDispatchedEvents = false;
        this.intervalHandle = null;
        this.attempts = 0;
        this.maxAttempts = 3;
        this.addListeners();
    }

    addListeners() {
        document.querySelector('body').addEventListener(constants.EVENTS.GTM_DISPATCH, (e) => {
            this.dispatchEvents();
        });
      }

    /**
     * Ensure tagmanager (dataLayer) exists
     */
    hasTagmanager() {
        return typeof dataLayer != 'undefined';
    }

    /**
     * Only run this method from index.js file on domready event
    */
    dispatchEventsOnPageLoad() {
        this.dispatchEvents();
        this.attempts++;

        // if events has not dispatched allow 300ms for gtm to load. repeat n times
        if (!this.hasDispatchedEvents && !this.intervalHandle && this.attempts <= this.maxAttempts) {
            this.intervalHandle = setInterval(() => {
                this.dispatchEventsOnPageLoad();
            }, 300);
        }

        // clear interval after n times or if events are succesfully sent
        if (this.hasDispatchedEvents || this.attempts > this.maxAttempts) {
            clearInterval(this.intervalHandle);
        }
    }

    dispatchEvents() {
        const cookieLevels = this.getCookieLevels();

        if (!cookieLevels || !this.hasTagmanager()) {
            return;
        }
        for (let i = 0; i < cookieLevels.length; i++) {
            //console.log('Dispatching event: ' + cookieLevels[i].toString());
            window.dataLayer.push({
                event: cookieLevels[i].toString()
            });
        }
        this.hasDispatchedEvents = true;
    }

    getCookieLevels() {
        let value = this.settingsCookie.getCookieValue();
        return value ? value.split('|') : null;
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/TagManagerModule.js